import { render } from "./WelfareBook.vue?vue&type=template&id=2482c0a8&scoped=true"
import script from "./WelfareBook.vue?vue&type=script&lang=js"
export * from "./WelfareBook.vue?vue&type=script&lang=js"

import "./WelfareBook.vue?vue&type=style&index=0&id=2482c0a8&scoped=true&lang=css"

import exportComponent from "/Volumes/P310_1T/workspace_cpp/slls_txt/slls-web-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2482c0a8"]])

export default __exports__